import { urls } from "common/urls";
import React from "react";
import { Link } from "react-router-dom";

interface Props {
  message?: string;
}

export const NoDataError: React.FC<React.PropsWithChildren<Props>> = ({
  message,
}) => {
  return (
    <>
      <p>En feil oppstod: {message ? message : "Vi fant ingen data"}</p>
      <Link to={urls.frontPage}>Gå tilbake til forsiden</Link>
    </>
  );
};
